let Keys = {
    install(Vue, options) {
        Vue.Keys = {
            LANGUAGE: "LANGUAGE",
            TOKEN: "TOKEN",
            USER: "USER",

            PRO_SIMPLEUSER: 1,
            PRO_ADMINACCESSPOINT: 2,
            PRO_ADMINSERVICELINE: 3
        };
    }
};

export {
    Keys
};